import React from "react";
import { MetricDashboardBox } from "./MetricDashboardBox";
import { Article } from "@mui/icons-material";
import { useQuery } from "@tanstack/react-query";
import httpClient from "../../httpClient";
import { useTranslate } from "react-admin";

type PostCountMetric = {
	current_value: number;
	previous_value: number;
};

export function PostMetricDashboardBox({
	providers,
	fromDate,
	toDate,
}: {
	providers: string[];
	fromDate: string;
	toDate: string;
}) {
	const { data, isLoading } = useQuery<PostCountMetric>({
		queryKey: ["posts_count", providers, fromDate, toDate],
		queryFn: async () => {
			const url = new URL(
				`${process.env.REACT_APP_SOCIAL_MODERATOR_URL}/statistics/posts_count`,
			);

			url.searchParams.append("from_date", fromDate);
			url.searchParams.append("to_date", toDate);

			if (providers.length > 0) {
				url.searchParams.append("providers", providers.join(","));
			}

			const response = await httpClient(url);

			return response?.json;
		},
		staleTime: 5 * 60 * 1000,
	});

	const translate = useTranslate();

	const getTrend = () => {
		if (!data) {
			return "flat";
		}

		if (data.current_value === data.previous_value) {
			return "flat";
		}

		return data.current_value > data.previous_value ? "up" : "down";
	};

	const getTrendValue = () => {
		if (!data) {
			return "0";
		}

		const sign = data.current_value >= data.previous_value ? "+" : "-";

		return `${sign}${Math.abs(data.current_value - data.previous_value)}`;
	};

	return (
		<MetricDashboardBox
			title={translate("pos.social_networks.dashboard.metrics.posts")}
			icon={Article}
			metric={data ? `${data.current_value}` : "0"}
			trend={getTrend()}
			trendValue={getTrendValue()}
		/>
	);
}
